import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      background: "linear-gradient(252.43deg, #3395A1 1.11%, #0A144D 100%)",
      width: "100%",
      height: "100vh",
    },
    mainSectionParent: {
      display: "flex",
      width: "100%",
      justifyContent: "center",
      paddingBottom: 100,
    },
    content: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: "40px 40px 0px 120px",
      width: "100%",
    },
    header: {
      marginBottom: "32px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      width: "100%",
    },
    heading: {
      ...theme.fonts.label2,
      color: theme.colors.textDefault,
    },
    closeButton: {
      color: theme.colors.textSubtle,
    },
    mfaSettingsHeaderContainer: {
      display: "flex",
    },
    mfaSettingsHeader: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
      margin: 0,
    },

    editLink: {
      ...theme.fonts.h5,
      color: theme.colors.action,
      height: "auto",
      marginLeft: "8px",
    },

    securitySettings: {
      display: "flex",
      flexDirection: "column",
    },

    authenticator: {
      marginTop: "16px",
      display: "flex",
    },
    mfaCloseIcon: {
      color: theme.colors.error,
      marginTop: "1px",
    },
    mfaCheckIcon: {
      color: theme.colors.affirmation,
      marginTop: "1px",
    },

    authenticatorName: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      marginLeft: "8px",
    },
    passkeyName: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
    },
    mfaSettings: {
      width: "50%",
      marginTop: "32px",
    },
    mfaUsername: {
      width: "75%",
    },
    mfaPassword: {
      width: "50%",
      marginTop: "32px",
    },
    mfaPasskey: {
      width: "75%",
      marginTop: "32px",
    },
    passwordHeader: {
      display: "flex",
    },
    usernameHeader: {
      display: "flex",
    },
    usernameLabel: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
      margin: 0,
    },
    passwordLabel: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
      margin: 0,
    },
    password: {
      ...theme.fonts.h5,
      color: theme.colors.textDefault,
    },
    buttonContainer: {
      marginTop: "80px",
    },
    goToDashboardButton: {
      padding: "0",
    },
    addPasskeyButton: {
      borderRadius: 0,
      marginTop: "16px",
    },
    noPasskeysContainer: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      marginTop: "16px",
    },

    passkeyLabel: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
    },
    passkeyDate: {
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
      marginLeft: "8px",
    },

    passkeyDeleteIcon: {
      color: theme.colors.error,
      marginLeft: "8px",
    },
    deleteModalContent: {
      padding: "4px",
      minWidth: "400px",
      borderRadius: 0,
      "& > div": {
        borderRadius: "0 !important",
      },
    },
    deleteModalTitle: {
      ...theme.fonts.h3,
      color: theme.colors.textDefault,
      margin: "0 0 16px 0",
      fontWeight: 700,
    },
    deleteModalBody: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      margin: "0 0 24px 0",
    },
    deleteModalActions: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "16px",
      "& button": {
        borderRadius: 0,
      },
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
